import { render } from "./InitiativeCategories.vue?vue&type=template&id=839b60fe&scoped=true"
import script from "./InitiativeCategories.vue?vue&type=script&lang=js"
export * from "./InitiativeCategories.vue?vue&type=script&lang=js"

import "./InitiativeCategories.vue?vue&type=style&index=0&id=839b60fe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-839b60fe"]])

export default __exports__